import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useChatRoomChannelWebSocket } from "@circle-react/hooks/chatsV2/useChatRoomChannelWebSocket";
import { useShouldShowMessagingRoutes } from "@circle-react/hooks/useIsMessagingEnabled";
import { useEffect } from "react";
import { useQuery } from "react-query";

import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import { useChatHeaderApi } from "@/react/hooks/chats/useChatHeaderApi";

interface UnreadChatRoomsResponse {
  chat_room_uuids: string[];
}

export const useChatNotification = ({
  community,
}: { community?: any } = {}) => {
  const { currentCommunity, currentCommunityMember } = usePunditUserContext();
  const { showMessagesTab: shouldShowMessagesTab } =
    useShouldShowMessagingRoutes();
  const communityMemberId = community
    ? community.community_member_id
    : currentCommunityMember?.id;
  const communityId = community ? community.id : currentCommunity?.id;

  const {
    unreadChatRoomUuids,
    onEventReceive,
    setUnreadChatRoomUuids,
    unreadChatRoomUuidsRef,
    newUnreadChatRoomBatch,
    newUnreadChatRoomBatchRef,
  } = useChatHeaderApi({ communityId });

  const fetchRequest = () =>
    reactQueryGet(
      internalApi.chatRooms.unreadChatRooms({
        params: {
          community_id: communityId,
        },
      }),
    );

  const { data } = useQuery<UnreadChatRoomsResponse>({
    queryKey: ["UNREAD_CHAT_ROOMS_COUNT", communityId, communityMemberId],
    queryFn: fetchRequest,
    enabled: Boolean(communityId && communityMemberId && shouldShowMessagesTab),
  });

  useEffect(() => {
    if (data?.chat_room_uuids && communityId) {
      setUnreadChatRoomUuids(communityId, data.chat_room_uuids);
    }
  }, [communityId, data, setUnreadChatRoomUuids]);

  useChatRoomChannelWebSocket({
    communityMemberId,
    onMessageReceive: (data: any) => {
      onEventReceive(unreadChatRoomUuidsRef.current, data, communityMemberId);
    },
    canCreateConnection: Boolean(communityId && communityMemberId),
  });

  //componentWillUpdate
  useEffect(() => {
    unreadChatRoomUuidsRef.current = unreadChatRoomUuids;
  }, [unreadChatRoomUuids]);

  //componentWillUpdate
  useEffect(() => {
    newUnreadChatRoomBatchRef.current = newUnreadChatRoomBatch;
  }, [newUnreadChatRoomBatch]);

  const unreadChatCount = unreadChatRoomUuids.length;

  return { unreadChatCount, unreadChatRoomUuids };
};
